const promptForUnsavedChanges = function (event: BeforeUnloadEvent) {
  event.returnValue = 'You have unsaved changes.';
};

export const attachUnsavedChanges = () => {
  window.addEventListener('beforeunload', promptForUnsavedChanges);
};

export const detachUnsavedChanges = () => {
  window.removeEventListener('beforeunload', promptForUnsavedChanges);
};
